import React from 'react';
import { Check, X } from 'lucide-react';
export function TargetAudience() {
  const forYou = ['Oficinista 30-50 años (MX/CO)', 'Insomnio laboral 3+ noches/semana', 'Acceso a tianguis/plazas semanales', 'Cansado de pastillas y resaca', 'Quiere 8 horas sin adicción', 'Estrés alto por deadlines/familia', 'Urgencia de probar plantas locales'];
  const notForYou = ['Embarazadas o en lactancia', 'Toma sedantes/antidepresivos (sin consultar doc)', 'Alérgicos a asteráceas (manzanilla)', 'Niños menores de 12 años', 'Busca pastillas mágicas rápidas para siempre'];
  return <section className="py-12 md:py-20 px-4 bg-forest-900" data-id="element-254">
      <div className="max-w-5xl mx-auto" data-id="element-255">
        <div className="grid md:grid-cols-2 gap-5 md:gap-8" data-id="element-256">
          {/* For You */}
          <div className="bg-forest-800 rounded-xl p-5 md:p-8 border-t-4 border-green-500 shadow-lg" data-id="element-257">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-4 md:mb-6 flex items-center gap-3" data-id="element-258">
              <div className="bg-green-500/20 p-2 rounded-full" data-id="element-259">
                <Check className="w-6 h-6 text-green-500" data-id="element-260" />
              </div>
              Esto ES Para Ti Si...
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-261">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-cream-200" data-id="element-262">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-263" />
                  <span data-id="element-264">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-forest-800 rounded-xl p-5 md:p-8 border-t-4 border-red-500/70 shadow-lg opacity-90" data-id="element-265">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-cream-300 mb-4 md:mb-6 flex items-center gap-3" data-id="element-266">
              <div className="bg-red-500/10 p-2 rounded-full" data-id="element-267">
                <X className="w-6 h-6 text-red-500" data-id="element-268" />
              </div>
              Esto NO Es Para Ti Si...
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-269">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-cream-300/80" data-id="element-270">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-271" />
                  <span data-id="element-272">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}